import { queryOptions } from '@tanstack/react-query';

import { conversationsApi } from '../api/conversations-api';

import { conversationKeys } from './conversation-keys';

/**
 * A visitor who leaves sends no event (the API's 90 s marker simply lapses), so the list is
 * refetched every 30 s even with the socket live; without the socket, every 15 s.
 */
export const visitorsRefetchMs = (polling: boolean): number => (polling ? 15_000 : 30_000);

/** One store's live visitors: the store-pinned inbox and a thread's presence line. */
export function liveVisitorsQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: conversationKeys.visitors(storeId),
    queryFn: () => conversationsApi.visitors(storeId),
  });
}
